import React from "react";
import { Box, Grid, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Cached, Storage, Language } from "@mui/icons-material";
import { useNotification } from "../../../../contexts/NotificationContext";

const BIAnalytics = () => {
  const classes = useStyles();
  const { showInfo } = useNotification();

  return (
    <Box className={classes.root}>
      <div className={classes.title}>BI-аналитика</div>
      <div className={classes.message}>
        С помощью BI-аналитики вы можете воспользоваться готовыми шаблонами сложных отчетов или построить их с нуля самостоятельно.
      </div>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", mb: 3 }}>
        <div className={classes.alertCard}><Storage sx={{ fontSize: 18 }} /> 10+ внутренних источников данных</div>
        <div className={classes.alertCard}><Language sx={{ fontSize: 18 }} /> 7+ внешних источников данных</div>
        <div className={classes.alertCard}><Cached sx={{ fontSize: 18 }} /> Постоянное обновление данных</div>
      </Box>
      <Box mt="auto" />
      <Button
        fullWidth
        variant="contained"
        sx={{
          height: 44, backgroundColor: "#1CA673", textTransform: "none",
          fontSize: 14, fontWeight: 600,
          "&:hover": { backgroundColor: "#178F5F" },
        }}
        onClick={() => showInfo("Данный раздел находится в разработке")}
      >
        Перейти в BI-аналитику
      </Button>
    </Box>
  )
}

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 20,
    background: "#FFFFFF",
    borderRadius: 8,
    border: "1px solid #E4E4E7",
    boxSizing: "border-box",
  },
  title: {
    marginBottom: 8,
    fontSize: 16,
    color: "#27272A",
    fontWeight: 600,
    lineHeight: "20px",
  },
  message: {
    marginBottom: 16,
    fontSize: 14,
    color: "#71717A",
    lineHeight: "20px",
  },
  alertCard: {
    gap: 8,
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    borderRadius: 8,
    background: "#E4FBF1",
    border: "1px solid #1CA673",
    fontSize: 13,
    color: "#1CA673",
    fontWeight: 600,
    lineHeight: "18px",
  },
}));

export default BIAnalytics;
